import BxTable from "../bx-components/BxTable";
import BxTableColumn from "../bx-components/BxTableColumn";
import BxBtn from "../bx-components/BxBtn";
import BxOrderStatus from "../bx-components/BxOrderStatus";
export default {
  name: "movement-box-detail",
  components: { BxOrderStatus, BxBtn, BxTableColumn, BxTable },
  props: {
    id: {
      type: [Number, String]
    },
    orderId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      columns: [],
      data: [],
      dataList: [],
      receptionBoxData: {},
      receptionTime: "",
      waitingTime: "",
      itemCount: "",
      name: "",
      status: 0,
      contents: [],
      reloadInterval: null,
      API_BASE: process.env.VUE_APP_API_BASE,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    parseSizes(sizes){
      if (sizes === null || sizes === undefined) { // true
        return ""
      } else {
        let size_list=[]
        sizes.forEach(size => size_list.push(size.country + "/" + size.value))
        if (size_list.length == 0) {
          size_list = ""
        } else {
          size_list = size_list.toString().replace("[", "").replace("]", "").replace("--", "Standard")
        }
        return size_list
      }
    },
    async getData() {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        this.receptionBoxData = await this.$api.reception_boxes.get(this.id);
        this.exitTime = this.receptionBoxData.reading_time;
        this.status = this.receptionBoxData.status;
        this.waitingTime = this.receptionBoxData.waiting_time;
        this.name = this.receptionBoxData.order_name;
        this.report = await this.$api.reception_boxes.report(this.id);
        this.itemCount = this.report.length;
        this.data = this.report.map((item, key) => {
          return {
            gtin: item.gtin,
            itemType: item.item_type,
            theorical_item_count: item.theorical_item_count,
            real_item_count: item.real_item_count,
            cloth_type: item.cloth_type,
            id: item.id,
            size: this.parseSizes(item.sizes),
            color: item.colour,
            model: item.model,
            section: item.section,
            description: item.description,
            ratingPercent:
              (item.real_item_count / item.theorical_item_count) * 100
          };
        });

        this.columns = [
          {
            field: "gtin",
            label: this.$t("lang.online.box_detail.table_field_1")
          },
          {
            field: "theorical_item_count",
            label: this.$t("lang.online.box_detail.table_field_2")
          },
          {
            field: "real_item_count",
            label: this.$t("lang.online.box_detail.table_field_3")
          },
          {
            field: "description",
            label: this.$t("lang.online.box_detail.table_field_10")
          },
          {
            field: "section",
            label: this.$t("lang.online.box_detail.table_field_4")
          },
          {
            field: "itemtype",
            label: this.$t("lang.online.box_detail.table_field_5")
          },
          {
            field: "model",
            label: this.$t("lang.online.box_detail.table_field_6")
          },
          {
            field: "color",
            label: this.$t("lang.online.box_detail.table_field_7")
          },
          {
            field: "size",
            label: this.$t("lang.online.box_detail.table_field_8")
          },
          {
            field: "ratingPercent",
            label: this.$t("lang.online.box_detail.table_field_9"),
            width: 200
          }
        ];
      } catch (error) {
        console.error(error);
      } finally {
        this.shouldLoading = false;
      }
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.reloadInterval = setInterval(
        this.getData,
        process.env.VUE_APP_RELOAD_TIME
      );
    }
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
